import { render, staticRenderFns } from "./DataIteratorNoResultsContainer.vue?vue&type=template&id=202037a0&scoped=true"
import script from "./DataIteratorNoResultsContainer.vue?vue&type=script&lang=js"
export * from "./DataIteratorNoResultsContainer.vue?vue&type=script&lang=js"
import style0 from "./DataIteratorNoResultsContainer.vue?vue&type=style&index=0&id=202037a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202037a0",
  null
  
)

export default component.exports